module.exports = __webpack_public_path__ + "img/edit_delete_campaign.107c9172.png";